<template>
	<a-layout class="smart-home">
		<a-layout-sider v-model="collapsed" width="220" :trigger="null" collapsible>
			<div class="logo">
				<img v-if="keepWhy" :style="collapsed === true ? 'height:30px; margin: 0 auto;' : 'height:60px; margin: 0 15px;'"
					:src="collapsed === true ? logoWhiteSmall : logoWhite" alt="" />
				<img v-else :style="collapsed === true ? 'height:30px; margin: 0 auto;' : 'height:30px; margin: 0 20px;'"
					:src="collapsed === true ? logoWhiteSmall : logoWhite" alt="" />
				<!-- <img src="../../assets/bacD.png" /> -->
				<!-- <span>壹云汇</span> -->
				<!-- <span class="logo-text" style="fontSize:16px">壹云汇</span> -->
			</div>
			<div class="meunsWrap">
				<div class="meuns">
					<a-menu theme="light" mode="inline" :inlineCollapsed="false" v-model="selectedKeys"
						@openChange="onOpenChange" :openKeys="openKeys" :defaultSelectedKeys="defaultSelectedKeys">
						<template v-for="(m, index) in menus">
							<a-sub-menu :key="index" v-if="m.children.length > 0">
								<slot slot="title">
									<i :class="'iconfont ' + m.icon" style="margin-right:8px;" />
									<span class="menu-text">{{ m.title }}</span>
								</slot>
								<a-menu-item :class='[spanTitleAct==x.title ? "spanTitle" : ""]' :key="x.titleEn"
									v-for="x in m.children" @click="go(x)">
									<span>{{ x.title }}</span>
								</a-menu-item>
							</a-sub-menu>
							<a-menu-item :key="index" v-else @click="go(m)">
								<i :class="'iconfont ' + m.icon" style="margin-right:8px;" />
								<span class="menu-text">{{ m.title }}</span>
							</a-menu-item>
						</template>
					</a-menu>
				</div>
			</div>
		</a-layout-sider>
		<a-layout>
			<a-layout-header>
				<div class="header-one">
					<span>
						<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'"
							@click="() => (collapsed = !collapsed)" />
					</span>


					<!-- <div class="chinese">
            <a-button
              @click="changeLocale('en-us')"
              v-show="this.localeval == 'zh-cn'"
            >
              English
            </a-button>
            <a-button
              @click="changeLocale('zh-cn')"
              v-show="this.localeval == 'en-us'"
            >
              中文
            </a-button>
          </div> -->
					<span class="right">
						<span style="display: flex;align-items: center;">
							<div style="border-right: 1px solid #E9F0F5;margin-right: 20px;">
								<!-- <a-icon @click="loadPage()" class="icon-load" type="reload" /> -->
								<i class="iconfont icon-shuaxin midDiv-icon" style="font-size: 16px;color: #aebac8;" @click="loadPage()" />
							</div>

							<!-- <img  @click="(e) => e.preventDefault()" class="userImg" src="../assets/usericon.svg" alt="" /> -->
							<!-- <a-avatar :size="24" style="margin-right:8px;" :src="imgs" /> -->
							<!-- <span style="margin-right:20px;">用户名</span> -->
							<el-dropdown>
								<!-- <a class="ant-dropdown-link" style="color:#788CA2" @click="(e) => e.preventDefault()">
									<i class="iconfont icon-jiantou-copy-copy midDiv-icon" style="margin-right: 0px !important;margin-left: 10px;color: #93A3B5;"></i>
								</a> -->
								<img  @click="(e) => e.preventDefault()" class="userImg" src="../assets/usericon.svg" style="cursor:pointer" alt="" />
						
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item class="dropdowDivTop" style="background: #EFF3FA;">
											<div class="dropdowDiv-top">
												<p style="margin-bottom: 5px;">商户编号：<span class="dropdowDiv-span"></span> {{ this.merchantNo }}</p>
												<p>登陆账号：<span class="dropdowDiv-span"></span>{{ this.baseInfoRegist.phoneAreaCode }} {{ this.userNames }}</p>
											</div>
										</el-dropdown-item>
										<div class="dropdowDiv-box" v-if="owTag!='OW'">
											<!-- <el-dropdown-item class="dropdowDiv-item" :style="brrs[0] != null ? 'margin-bottom: 18px;' : ''">
												<div @click="modifyPassword">
													<i class="iconfont icon-mima" style="color: #21222B;"></i>
													<span style="marginLeft:8px;fontSize:14px">密码修改</span>
												</div>
											</el-dropdown-item> -->
											<el-dropdown-item v-if="brrs[0] != null&&brrs[0].title != '商户服务'" class="dropdowDiv-item" style="margin-bottom: 18px;">
												<div @click="viewRate">
													<i class="iconfont icon-feishuaiguanli" style="color: #21222B;"></i>
													<span style="marginLeft:8px;fontSize:14px">费率查询</span>
												</div>
											</el-dropdown-item>
											
											<el-dropdown-item v-show="keepWhy==false"  v-if="brrs[0] !=null" class="dropdowDiv-item">
												<div @click="commonProblemClick">
													<i class="iconfont icon-changjianwenti" style="color: #21222B;"></i>
													<span style="marginLeft:8px;fontSize:14px">常见问题</span>
												</div>
											</el-dropdown-item>
										</div>
										<el-dropdown-item class="dropdowDiv dropdowDiv-bot dropdowDiv-box">
											<div @click="loginOut">
												<i class="iconfont icon-tuichu" style="color: #21222B;"></i>
												<span style="marginLeft:8px;fontSize:14px">退出登录</span>
											</div>
										</el-dropdown-item>
									</el-dropdown-menu>
							</el-dropdown>
						</span>
					</span>
				</div>
				<div class="midDiv" ref="pagemidDiv">
					<div v-if="brrs[0] != null" @click="pageLeft()" class="midDiv-divRight midDiv-pou"
						style="background: #FFFFFF;z-index:2">
						<i class="iconfont icon-left midDiv-icon midDiv-color" style="margin-right: 0px !important;"></i>
						
					</div>
					<div v-if="brrs[0]!=null" class="middle" ref="page" :class="slideRight?'slideRight':'slideLeft'">

						<div @click="navPush(item,index)" v-for="(item, index) in brrs" :key="index" :tab="item.title"
							:class="middle_act == item.title ? 'middle-action' : ''">
							<span>{{item.title }}</span>
							<i v-if="item.title!=middle_act&&item.title!='后台首页'" class="iconfont icon-guanbi middle-icon" style="margin-right: 0px !important;"></i>
							<i v-if="item.title==middle_act&&item.title!='后台首页'" @click.stop="log(index)" class="iconfont icon-guanbixuanzhong middle-icon-action" style="margin-right: 0px !important;"></i>
						
						</div>

					</div>
					<div v-if="brrs[0] != null" class="midDiv-right">
						<div class="midDiv-divRight midDiv-pou" @click="pageRight()" style="border-left: 1px solid #e9f0f5;">
							<i class="iconfont icon-jiantouright midDiv-icon midDiv-color" style="margin-right: 0px !important;"></i>
						</div>
						<a-dropdown>
							<div class="midDiv-pou">
								<i class="iconfont icon-jiantou-copy-copy midDiv-icon midDiv-color" style="margin-right: 0px !important;"></i>
							</div>
							<a-menu slot="overlay">
								<a-menu-item>
									<a href="javascript:;" @click="pageClick('All')">关闭所有</a>
								</a-menu-item>
								<a-menu-item>
									<a href="javascript:;" @click="pageClick('Other')">关闭其他</a>
								</a-menu-item>
							</a-menu>
						</a-dropdown>
					</div>
				</div>

				<!-- <div class="header-two">
          <span v-for="(item, index) in brr" :key="index">
            <span
              @click="navPush(item, index)"
              :class="actived === index ? 'activesClass' : 'tags'"
              v-if="item.title == '商户入网'"
            >
              <span
                ><span>{{ item.title }}</span></span
              >
            </span>
            <span
              v-else
              @click="navPush(item, index)"
              :class="actived === index ? 'activesClass' : 'tags'"
            >
              <span
                ><span>{{ item.title }}</span
                ><span
                  :class="actived === index ? 'activeRemove' : 'remove'"
                  @click.stop="removeItem(index)"
                  v-show="item.title !== '后台首页'"
                >
                  <i :class="'iconfont ' + 'icon-guanbi'"></i> </span
              ></span> </span
          ></span>
        </div> -->
			</a-layout-header>
			<a-config-provider :locale="locale">
				<a-layout-content ref="main">
					<keep-alive exclude="shopQuery,globalRemittance">
						<router-view></router-view>
					</keep-alive>
				</a-layout-content>
			</a-config-provider>
			<div v-show="keepWhy" class="keepUrlCss">
				<a href="https://beian.miit.gov.cn" target="_blank" style="color: #909399;">粤ICP备2021017313号</a>
			</div>
		</a-layout>
		<!-- <loginOut v-if="visible" @close="close" :visibles="this.visible"></loginOut> -->
		<a-modal title="退出登录" :visible="visibles" :width="460" @cancel="close" class="action">
			<template slot="footer">
				<a-button type="primary" @click="create" class="sure">确定</a-button>
				<a-button @click="close" class="qu">取消</a-button>
			</template>
			<div class="login">
				<div>确定要退出登录吗?</div>
			</div>
		</a-modal>

	</a-layout>
</template>
<script>
	// import menus from '../commons/menus'
	import Cookies from "js-cookie";
	import loginOut from '../views/loginOut-modal.vue'
	import zhCN from 'ant-design-vue/es/locale-provider/zh_CN'
	import moment from 'moment'
	import 'moment/locale/zh-cn'
	import vueBus from '../commons/vueBus';

	moment.locale('zh-cn')
	const EN = 'en-us'
	const ZH = 'zh-cn'
	export default {
		components: {
			loginOut,
		},
		name: 'Home',
		data() {
			return {
				logoWhiteSmall: require('../assets/logo-white-small.svg'),
				logoWhite: require('../assets/logo-white.svg'),
				reflags: false,
				userNames: '',
				locale: zhCN,
				localeval: 'zh-cn',
				imgs: '',
				visibles: false,
				datas: [],
				isRouterAlive: true,
				visible: false,
				defaultSelectedKeys: [this.$route.path],
				openKeys: [''],
				collapsed: false,
				exitConfirm: false,
				menus: [],
				user: {},
				selectedKeys: [],
				loginNames: '',
				arr: [],
				brr: [],
				brrs: [],
				actived: '',
				middle_act: '', //当前导航显示的内容
				spanTitleAct: '', //二级菜单的样式
				slideRight: false, //导航栏滑动左右控制
				timeWidth: '', //监听当导航栏宽度
				timeWidthWhy: false ,//监听是否可以滑动
				keepWhy:false,
				merchantNo:'',
				owTag:'',
				'baseInfoRegist':{}
			}
		},
		activated() {
			this.menus = JSON.parse(sessionStorage.getItem('data'))
			this.brrs = JSON.parse(sessionStorage.getItem('brrs')) || []
			this.merchantNo=sessionStorage.getItem('merchantNo')
			this.owTag=sessionStorage.getItem('owTag')
			this.baseInfoRegist=JSON.parse(sessionStorage.getItem('baseInfoRegist'))
			this.userNames = this.baseInfoRegist.phone
			if (this.menus != null) {
				if (this.brrs.length > 10) {
					this.$message.info('导航栏不能超过10个，请关闭其他后打开')
					this.brrs.splice(this.brrs.length - 1, 1)
					if (this.brrs[sessionStorage.getItem('middle_i')].fullPath) {
						this.$router.push(this.brrs[sessionStorage.getItem('middle_i')].fullPath)
					} else {
						this.$router.push(this.brrs[sessionStorage.getItem('middle_i')].titleEn)
					}
				}

				if (this.brrs.length == 0) {
					if (this.$route.query.data == undefined) {
						return false
					}
					if (this.$route.query.data[0].title == '后台首页') {
						this.brrs.push(this.$route.query.data[0])
						sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						this.$router.push('/backstage')
					} else {
						this.brrs.push(this.$route.query.data[0])
						sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						this.$router.push('/addedServices')
					}
					return false
				}


				if (this.brrs.length == 0) {
					this.brrs.push(this.menus[0])
				}
				// 导航是否左右滑动
				let that = this
				this.timeWidth = setInterval(function() {
					if (that.$refs.pagemidDiv.clientWidth - 150 < that.$refs.page.clientWidth) {
						that.timeWidthWhy = true
					} else {
						that.slideRight = false
					}
				}, 1000)
				this.userNames = Cookies.get('userNames')
				let brrsTitleEn = []
				this.middle_act =''
				
				for (let i in this.brrs) {
					if (this.brrs[i].titleEn == this.$route.path) {
						this.middle_act = this.brrs[i].title
						if (this.brrs[i].titleEn == this.$route.path) {
							this.brrs[i].titleNew = this.brrs[i].titleEn
						} else {
							this.brrs[i].titleNew = this.$route.path
						}

						sessionStorage.setItem('middle_i', i)
					}
					brrsTitleEn.push(this.brrs[i].titleEn)
				}
				
				if ((this.brrs[sessionStorage.getItem('middle_i')].titleEn != this.$route.fullPath && this.brrs[
						sessionStorage
						.getItem('middle_i')].title == sessionStorage.getItem('middle_act')) || (this.brrs[sessionStorage
						.getItem('middle_i')].fullPath != undefined && sessionStorage.getItem(
						'middle_act') == this.brrs[sessionStorage.getItem('middle_i')].title)) {
					this.brrs[sessionStorage.getItem('middle_i')].fullPath = this.$route.fullPath
				}
				// if (this.brrs[sessionStorage.getItem('middle_i')].fullPath != undefined && sessionStorage.getItem(
				// 		'middle_act') == this.brrs[sessionStorage.getItem('middle_i')].title) {
				// 	this.brrs[sessionStorage.getItem('middle_i')].fullPath = this.$route.fullPath
				// }
				sessionStorage.setItem('brrs', JSON.stringify(this.brrs))

				if (brrsTitleEn.indexOf("/wantLoanApply") != '-1') {
					if (this.$route.path == '/loanApplyList' || this.$route.path == '/loanApply') {
						this.middle_act = "我要贷款"
					}
				}
				if (brrsTitleEn.indexOf("/haiMaiList") != '-1' || brrsTitleEn.indexOf("/haiMaiApply") != '-1') {
					if (this.$route.path == '/haiMaiList' || this.$route.path == '/haiMaiApply') {
						this.middle_act = "海购卡"
					}
				}
				
				
				if (this.middle_act == '') {
					this.middle_act = sessionStorage.getItem('middle_act')
				}
				sessionStorage.setItem('middle_act', this.middle_act)

				for (let [index, i] of this.menus.entries()) {
					if (this.middle_act == '海购卡' || this.middle_act == '后台首页' || this.middle_act == '我要贷款' || this
						.middle_act == '商户入网'|| this.middle_act == '密码修改'|| this.middle_act == '费率查询') {
						this.openKeys = ['']
						this.spanTitleAct = ''
						sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys))
					} else {
						for (let j of i.children) {
							if (j.title == this.middle_act) {
								let openKeys = [index]
								this.spanTitleAct = j.title
								sessionStorage.setItem('openKeys', JSON.stringify(openKeys))
							}
						}
					}

				}
				if (JSON.parse(sessionStorage.getItem('openKeys'))) {
					this.openKeys = JSON.parse(sessionStorage.getItem('openKeys'))
				}
				
				//全球汇款收款账号,结汇收款账号添加新账户
				for (let i in this.brrs) {
					if((this.$route.path == '/retrieveMoneryList'&&this.brrs[i].fullPath=='/accList')||(this.$route.path == '/myAccountList'&&this.brrs[i].fullPath=='/privateAcclist')){
						this.$router.push(this.brrs[i].fullPath)
					}
				}
				
			}
		},
		created() {
			if(window.location.href.indexOf('58.87.82.42')!=-1||window.location.href.indexOf('m.siweipay.com')!=-1){
								this.logoWhite=require('../assets/swh.png')
								this.logoWhiteSmall=require('../assets/swh.png')
								this.keepWhy=true
						}

			vueBus.$on("scrollTop", (message) => {
				this.scrollTop();
			})
			
			try {
				this.menus = this.$route.query.data || JSON.parse(sessionStorage.getItem('data'))
			} catch (e) {} finally {
				if (this.$route.query.data == undefined) {
					return false
				}
				if (this.$route.query.data[0].title == '后台首页' || this.$route.query.data[0].title == '海汇达-后台首页') {

					this.brrs.push(this.$route.query.data[0])
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					this.$router.push('/backstage')
				} else {
					this.brrs.push(this.$route.query.data[0])
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					this.$router.push('/addedServices')
				}
			}
			this.menus.forEach((item) => {
				if (item.title == '后台首页') {
					this.brr.push(item)
					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
				if (item.title == '商户服务') {
					this.brr.push(item)
					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
			})

			this.localeval = localStorage.getItem('localeval')
			this.locale = localStorage.getItem('localeval')
			if (this.locale === EN) {
				moment.locale(EN)
				this.locale = EN
			} else {
				moment.locale(ZH)
				this.locale = zhCN
			}

		},
		mounted() {
			this.brr = JSON.parse(sessionStorage.getItem('brr')) || []
			this.userNames = Cookies.get('userNames')
			
			vueBus.$on("bload", value => {
				this.userNames = value

				this.menus = JSON.parse(localStorage.getItem('datalist'))
				if (this.menus == null) {
					this.$router.push("/loginrealName");
				}
				if (this.menus) {
					if ("商户入网" == this.menus[0].title) {
						this.menus[0].title = "商户服务";
						this.menus[0].titleEn = "/addedServices";
						this.menus[0].icon = "icon-fuwu";
					}
				}

				sessionStorage.setItem("data", JSON.stringify(this.menus));
				this.$router.push({
					path: "/home",
					query: {
						data: this.menus
					}
				});
			});
			this.renderSelect()
		},
		methods: {
			moment,
			create() {
				this.$http.get('sys/loginOut').then((res) => {
					if (res.data.code == 0) {
						this.visibles = false
						sessionStorage.clear()
						Cookies.remove('token')
						this.$router.push({
							path: '/login'
						})
					} else if (res.data.code == 600) {
						this.$message.info('请登录')
					} else {
						this.$message.info(res.data.msg)
					}
				})
			},
			pageLeft() {
				if (!this.timeWidthWhy) {
					return false
				}
				if (this.$refs.pagemidDiv.clientWidth - 150 < this.$refs.page.clientWidth) { //可以滑动
					this.slideRight = false
				}
			},
			pageRight() {
				if (!this.timeWidthWhy) {
					return false
				}
				// this.$refs.pagemidDiv.clientWidth-150   导航栏总体宽度
				// this.$refs.page.clientWidth    导航栏内容宽度
				if (this.$refs.pagemidDiv.clientWidth - 150 < this.$refs.page.clientWidth) { //可以滑动
					this.slideRight = true
				}
			},
			pageClick(type) {
				if (this.brrs.length == 1 || this.brrs[0] == null) {
					return false
				}
				if (type == 'All') { //关闭所有
					let optionRoutes = this.$router.options.routes.slice(-1)[0].children
					for (let i of optionRoutes) {
						if(!i.meta.keepAlive){
							i.meta.keepAlive=true
						}
					}
					this.brrs = [this.brrs[0]]
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					sessionStorage.setItem('middle_act', JSON.stringify(this.brrs[0].title))
					sessionStorage.setItem('middle_i', 0)
					if (this.middle_act != '后台首页') {
						if (this.brrs[0].fullPath != undefined && this.brrs[0].fullPath != this.brrs[0].titleEn) {
							this.$router.push({
								path: this.brrs[0].fullPath
							})
						} else {
							this.$router.push({
								path: this.brrs[0].titleEn
							})
						}
					} else {
						this.loadPage()
					}
				} else { //关闭其他
					if (this.middle_act != '后台首页') {
						this.brrs = [this.brrs[0], this.brrs[sessionStorage.getItem('middle_i')]]
					} else {
						this.brrs = [this.brrs[0]]
						sessionStorage.setItem('middle_act', JSON.stringify(this.brrs[0].title))
						sessionStorage.setItem('middle_i', 0)
					}
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					let optionRoutes = this.$router.options.routes.slice(-1)[0].children
					for (let i of optionRoutes) {
						if(!i.meta.keepAlive&&i.path!=this.brrs[sessionStorage.getItem('middle_i')].titleEn){
							i.meta.keepAlive=true
						}
					}
				}
			},
			loadPage() { //刷新当前路由页面
				this.$router.push({
					path: "/loadPage"
				})
			},
			changeLocale(localeval) {
				this.localeval = localeval
				if (localeval === EN) {
					localStorage.setItem('localeval', localeval)
					moment.locale(EN)
					this.$i18n.locale = EN
					this.locale = EN
				} else {
					localStorage.setItem('localeval', localeval)
					moment.locale(ZH)
					this.$i18n.locale = ZH
					this.locale = zhCN
				}
			},
			log(e) {

				if (this.brrs.length == 1 || this.brrs[e].title == '后台首页' || this.brrs[e].title == '商户服务') {
					return false
				}
				let optionRoutes = this.$router.options.routes.slice(-1)[0].children

				this.$common.TabFun(optionRoutes)
				// this.$route.meta.keepAlive=true
				// this.$store.commit('iskeepAlive', this.brrs[e].titleEn.split('/')[1]);
				if (this.brrs.length - 1 == e) {
					this.brrs.splice(e, 1);
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					this.navPush(this.brrs[this.brrs.length - 1], this.brrs.length - 1)
				} else {
					this.brrs.splice(e, 1);
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					this.navPush(this.brrs[e], e)
				}
			},
			navPush(items, index) {

				sessionStorage.setItem('middle_act', items.title)
				sessionStorage.setItem('middle_i', index)
				// console.log(this.menus)

				if (items.fullPath != undefined && items.fullPath != items.titleEn) {
					this.$router.push(items.fullPath)
				} else {
					this.$router.push(items.titleEn)
				}
			},
			getMsgFormSon(data) {
				this.visibles = data
			},

			close() {
				this.visibles = false
			},
			modifyPassword() {
				if (this.brrs[0] != null) {
					let newarr = []
					for (let i of this.brrs) {
						newarr.push(i.title)
					}
					if (newarr.includes('密码修改') == false) {
						this.brrs.push({
							children: [],
							href: "page/main.html",
							icon: "",
							permissions: null,
							spread: "false",
							title: "密码修改",
							titleEn: "/modifyPersonalPass"
						})
						sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
					}
				}
				this.$router.push({
					path: "/modifyPersonalPass"
				})
			},
			viewRate() {
				let newarr = []
				for (let i of this.brrs) {
					newarr.push(i.title)
				}
				if (newarr.includes('费率查询') == false) {
					this.brrs.push({
						children: [],
						href: "page/main.html",
						icon: "",
						permissions: null,
						spread: "false",
						title: "费率查询",
						titleEn: "/rateQuery"
					})
					sessionStorage.setItem('brrs', JSON.stringify(this.brrs))

				}
				this.$router.push({
					path: "/rateQuery"
				})

			},
			loginOut() {
				this.visibles = true
				// this.$router.push({path:"/"})
			},
			// 常见问题
			commonProblemClick(){
				// let newarr = []
				// for (let i of this.brrs) {
				// 	newarr.push(i.title)
				// }
				// if (newarr.includes('常见问题') == false) {
				// 	this.brrs.push({
				// 		children: [],
				// 		href: "page/main.html",
				// 		icon: "",
				// 		permissions: null,
				// 		spread: "false",
				// 		title: "常见问题",
				// 		titleEn: "/commonProblem"
				// 	})
				// 	sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
				
				// }
				// this.$router.push({
				// 	path: "/commonProblem"
				// })
				this.$common.commonProbFun()
			},
			// 路由跳转
			go(x) {
				if (x.title == '海购卡' || x.title == '后台首页' || x.title == '我要贷款' || x.title == '商户入网'|| this.middle_act == '密码修改'|| this.middle_act == '费率查询') {
					this.openKeys = ['']
					sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys))
				}
				let brrsTitle = []
				for (let i of this.brrs) {
					brrsTitle.push(i.title)
				}
				if (brrsTitle.indexOf(x.title) == '-1') {
					this.brrs.push(x)
				}

				if (x.title == "海购卡") {
					this.PostService(x)

					return false
				}
				sessionStorage.setItem('brrs', JSON.stringify(this.brrs))

				if (x.title == '商户入网') {
					this.actived = this.brr.length
				} else if (x.title == '后台首页') {
					this.reflags = false
					this.actived = this.brr.length
				} else {
					this.reflags = true
					this.brr.push(x)
					this.actived = this.brr.length - 1
					this.brr = [...new Set(this.brr)]

					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				}
				const pathname = window.location.pathname
				if (x.titleEn !== pathname) {

					this.$router.replace(x.titleEn)
				}
			},
			removeItem(index) {

				this.actived = index - 1
				if (
					index > 0 &&
					this.$route.path.indexOf(this.brr[index].titleEn) != '-1'
				) {

					this.$router.replace(this.brr[index - 1].titleEn)
					this.brr.splice(index, 1)
					sessionStorage.setItem('brr', JSON.stringify(this.brr))
				} else if (index > 0) {
					this.brr.splice(index, 1)
				}

				// this.$router.back()
			},
			// 海购卡路由跳转
			PostService(x) {
				this.$http
					.get('haicardapplyrecord/list?pageSize=10+&pageIndex=1')
					.then((res) => {
						if (res.data.code == 0) {
							if (res.data.data.length != 0) {
								for (let i of this.brrs) {
									if (i.title == '海购卡') {
										i.titleEn = '/haiMaiList'
									}
								}
								this.$router.push({
									path: '/haiMaiList'
								})
							} else {
								for (let i of this.brrs) {
									if (i.title == '海购卡') {
										i.titleEn = '/haiMaiApply'
									}
								}
								this.$router.push({
									path: '/haiMaiApply'
								})
							}
							sessionStorage.setItem('brrs', JSON.stringify(this.brrs))
						} else if (res.data.code == 600) {
							this.$message.info('请登录')
						} else {
							this.$message.warning(res.data.msg)
						}
					})
			},
			login() {
				// todo
				sessionStorage.clear()
				this.$router.push({
					path: '/login'
				})
			},
			renderSelect() {
				const pathname = window.location.pathname
				this.selectedKeys = [pathname]
			},
			onOpenChange(openKeys) {
				// 当菜单被展开时触发此处
				/*
				      经测试传入的变量openKeys是数组 点击已经展开的菜单时传入的是空数组
				      点击未展开的菜单时传入的是[当前展开菜单的key,点击的菜单key]
				      下面的if判断用openKeys === [] 无效 所以我只能判断数组length是否等于0
				      */
				if (openKeys.length !== 0) {
					this.openKeys = [openKeys[1]]
				} else {
					this.openKeys = ['']
				}
				sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys))
			},
			// 滚动条回顶部
			scrollTop() {
				let main = this.$refs.main
				main.$el.scrollTop = 0
			},
		},
		watch: {
			$route(to, from) {
				clearInterval(this.timeWidth)
				this.scrollTop()
				this.renderSelect()
			}
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .ant-layout-header {
		height: initial;
	}

	/deep/ .ant-menu-item-selected {
		background: initial !important;
		color: #9EA6CB !important;
	}

	/deep/ .ant-menu-item-active {
		color: #9EA6CB !important;
	}
	.keepUrlCss{
		width: 100%;
		text-align: center;
		font-size: 14px;
		margin: 15px 0;
	}
	.slideRight {
		position: absolute;
		right: 100px;
	}

	.slideLeft {
		position: absolute;
		left: 50px;
	}

	

	.icon-load {
		margin-right: 20px;
		font-size: 16px;
		cursor: pointer;
	}

	.spanTitle {
		background: linear-gradient(90deg, #4867D9 0%, #6081F3 100%) !important;
		color: #fff !important;
	}

	.middle::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.middle {
		scrollbar-width: none;
		/* firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.middle {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #788CA2;
		line-height: 40px;
		white-space: nowrap;
		overflow-x: scroll;
		display: flex;

		&>div {
			padding: 0px 18px;
			display: flex;
			align-items: center;
			border-top: 2px solid transparent;
			cursor: pointer
		}

		&-icon {
			font-size: 18px;
			margin-left: 8px;
			color: #BFCBD9;

			&-action {
				font-size: 15px;
				margin-left: 8px;
				color: #5575E9;
			}
		}

		&-action {
			background: #F6F8FC;
			border-top: 2px solid #5575E9 !important;
		}
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.smart-home {
		width: 100%;
		height: 100%;

		.logo {
			width: 100%;
			// padding-left: 15px;
			height: 60px;
			// background: #495179;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			>img {
				height: 30px;
			}

			>span {
				white-space: nowrap;
				margin-left: 10px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: rgba(255, 255, 255, 1);
				line-height: 22px;
			}
		}

		.iconfont {
			margin-right: 14px !important;
		}

		.ant-layout-header {
			// height: 100px;
			z-index: 99;
			background: rgb(255, 255, 255);
			padding: 0px;
			display: flex;
			box-shadow: 0px 0px 8px 0px rgba(67, 96, 218, 0.13);
			flex-flow: column;
		}

		.right {
			position: absolute;
			top: 0;
			right: 25px;
		}

		.ant-layout-content {
			position: relative;
			height: calc(~'100% - 100px');
			overflow: hidden;
			padding: 25px;
			background: #eff3fa;
			overflow-y: auto;
		}

		.meunsWrap {
			width: 220px;
			height: calc(~'100% - 60px');
			overflow-y: auto !important;
			overflow-x: hidden;
			padding-top: 15px;
		}

		.meuns {
			width: 220px;
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
		}

		.meuns::-webkit-scrollbar {
			display: none; //滚动条的样式去掉
		}

		.logo-text,
		.menu-text {
			opacity: 1;
			transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
				width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		}

		.ant-layout-sider-collapsed {

			.logo-text,
			.menu-text {
				display: inline-block;
				max-width: 0;
				opacity: 0;
			}
		}
	}

	.chinese {
		position: absolute;
		top: 0;
		right: 220px;
		width: 100px;
		// height: 30px;
	}
	.midDiv {
		display: flex;
		align-items: center;
		position: relative;
		overflow: hidden;
	
		&>div {
			line-height: 39px;
		}
	
		&-divRight {
			border-right: 1px solid #E9F0F5;
		}
	
		&-pou {
			cursor: pointer;
			width: 50px;
			text-align: center;
		}
		&-color{
			color: #383E61;
		}
		&-right {
			display: flex;
			align-items: center;
			border-top: 2px solid #ffffff;
			background: #FFFFFF;
			position: absolute;
			right: 0;
		}
	
		&-icon {
			width: 46px;
			font-size: 14px;
		}
	}
	.ant-layout-sider {
		// flex: 0 0 220px !important;
		// max-width: 220px !important;
		// min-width: 220px !important;
		// width: 220px !important;

		background: #fff !important;
	}

	.header-one {
		width: 100%;
		height: 60px;
		border-bottom: 1px solid #e9f0f5;
		position: relative;
		line-height: 60px;
	}

	.header-two {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0px 5px;
		color: #788ca2;
		font-size: 14px;
		box-sizing: border-box;
		overflow: hidden;

		.tags {
			border-top: 2px solid#fff;
			display: inline-block;
			height: 40px;
			background: #fff;
			line-height: 40px;
			padding: 0px 20px;
			border-right: 1px solid #e9f0f5;

			// margin-left: 1px;
			.remove {
				display: inline-block;
				width: 15px;
				height: 15px;
				line-height: 15px;
				margin-left: 12px;
				text-align: center;
				font-size: 7px;
			}
		}
	}

	.tags:hover {
		cursor: pointer;
		border-top: 2px solid#5575E9;
		background: #f6f8fc;
	}

	.activesClass {
		display: inline-block;
		height: 40px;
		background: #fff;
		line-height: 40px;
		padding: 0px 20px;
		border-top: 2px solid#5575E9;
		background: #f6f8fc;
		border-right: 1px solid #e9f0f5;
	}

	.activeRemove {
		width: 15px;
		height: 15px;
		text-align: center;
		display: inline-block;
		color: #fff;
		border-radius: 50%;
		background: #5575e9;
		line-height: 15px;
		font-size: 7px;
		margin-left: 12px;
	}

	.tags:hover .remove {
		width: 15px;
		height: 15px;
		text-align: center;
		display: inline-block;
		color: #fff;
		border-radius: 50%;
		background: #5575e9;
		line-height: 15px;
		font-size: 7px;
	}

	.trigger {
		margin-left: 25px;
	}

	.ant-dropdown-link {
		font-size: 14px;
	}

	.ant-dropdown-menu {
		// position: absolute;
		top: 15px;
	}

	.ant-dropdown-menu a:hover {
		background: #f6f8fc;
		color: #384c6d;
	}

	.userImg {
		width: 24px;
		height: 24px;
		margin-right: 8px;
	}

	.ant-menu-inline .ant-menu-item,
	.ant-menu-inline .ant-menu-submenu-title {
		width: calc(100%) !important;
	}

	.login {
		width: 100%;
		color: #252631;
		text-align: center;
		font-size: 14px;
	}

	.smart-form-inline {
		.ant-form-item {
			display: flex;

			margin-bottom: 12px;
		}

		.ant-form-item-label {
			min-width: 90px;
		}

		.ant-form-item-control-wrapper {
			flex: 1;
		}
	}

	.sure.ant-btn-primary {
		border-radius: 16px !important;
		background: #5575e9;
		border: none;
	}

	.qu.ant-btn {
		border-radius: 16px;

		color: #384c6d;
		background: #ffffff;
		border: 1px solid #e2e9ee;
	}

	.iconfont {
		cursor: pointer;
	}
</style>
